export const MAX_TITLE_LENGTH = 255;
